<template>
    <tr>
        <td>
            <a href="#" class="text-black font-sans-bold" @click.stop.prevent="editFestival">{{festival.title}}</a>
        </td>
        <td>{{festival.slug}}</td>
        <td>
            <!-- export -->
            <button class="font-sans-bold underline" @click.prevent.stop="exportEvents">Export Events</button>

        </td>
        <td>
            <!-- export -->
            <button class="font-sans-bold underline" @click.prevent.stop="syncFestivalEvents">Resync Events</button>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'FestivalItem',
        props: {
            festival: {
                required: true
            }
        },
        data: () => ({
        }),
        computed: {},
        methods: {
            editFestival() {
                this.$store.dispatch('getFestival', {
                    festival: this.festival,
                    router: this.$router
                })
            },
            exportEvents() {
                axios({
                    url: `/api/export/festival/${this.festival.id}/events`,
                    method: 'GET',
                    responseType: 'blob'
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'rihems-festival-events.csv');
                    document.body.appendChild(link);
                    link.click();
                }).catch((error) => {
                    console.log(error)
                });
            },
            syncFestivalEvents() {
                this.$toasted.show('Syncing festival events...')

                axios.post(this.$laroute.route('api.events.sync', { festival: this.festival.id } ))
                    .then((response) => {
                        this.$toasted.show('Events have been synced.')
                    })
                    .catch((error) => {
                        console.log(error)
                        console.log(error.response)
                    })
            }
        },
        mounted() {}
    }
</script>
